import { render, staticRenderFns } from "./accountJournalPeriodList.vue?vue&type=template&id=20b4c3f4"
import script from "./accountJournalPeriodList.vue?vue&type=script&lang=js"
export * from "./accountJournalPeriodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports